import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

const ECharts = ({
  options,
  height = '250px',
  setEChartRef,
  onEvents,
  notMerge = false,
  lazyUpdate = true,
  width = undefined,
}) => {
  const [chartRef, setChartRef] = useState();

  function handleWindowSize() {
    const chartInstance = chartRef?.getEchartsInstance();
    if (chartInstance) {
      chartInstance.resize();
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSize);
    handleWindowSize();
    return () => window.removeEventListener('resize', handleWindowSize);
  }, []);

  const otherOptions = {
    lazyUpdate,
    notMerge,
  };

  if (onEvents) {
    otherOptions.onEvents = onEvents;
  }

  return (
    <ReactECharts
      {...otherOptions}
      option={options}
      style={{ height, width }}
      ref={(e) => {
        setChartRef(e);
        if (setEChartRef) {
          setEChartRef(e);
        }
      }}
    />
  );
};

export default ECharts;
